var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.35906 7.2984C8.65195 7.59129 8.65195 8.06617 8.35906 8.35906C8.06617 8.65195 7.59129 8.65195 7.2984 8.35906L5.0003 6.06096L2.70221 8.35906C2.40931 8.65195 1.93444 8.65195 1.64154 8.35906C1.34865 8.06617 1.34865 7.59129 1.64154 7.2984L3.93964 5.0003L1.64154 2.7022C1.34865 2.40931 1.34865 1.93444 1.64154 1.64154C1.93444 1.34865 2.40931 1.34865 2.70221 1.64154L5.0003 3.93964L7.2984 1.64154C7.59129 1.34865 8.06617 1.34865 8.35906 1.64154C8.65195 1.93444 8.65195 2.40931 8.35906 2.7022L6.06096 5.0003L8.35906 7.2984Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b7877076b36f47ae299514a4dc05dafa.svg";
export { ForwardRef as ReactComponent };